import React from 'react';

// IMPORT STYLES
import './PersonMainInfo.css';

function PersonMainInfo({
  prof='Профессия',
  lastname='Фамилия',
  name='Имя',
  phone='Номер телефона'
}) {

  return(
    <div className='person-main-info'>
      <p className='person-main-info__prof'>{prof}</p>
      <p className='person-main-info__name'>{lastname}</p>
      <p className='person-main-info__name'>{name}</p>
      <a className='person-main-info__phone' href='tel: +79122434390'>{phone}</a>
    </div>
  );
}
export default PersonMainInfo;
